import axios from 'axios';

import PublicStore from 'Site/State/Store';
import { loadedSiteData, fatalError } from 'Site/State/ActionCreators';

export function loadSite () {
  axios.get('/data/PublicSiteData.json')
    .then(({ data }) => PublicStore.dispatch(loadedSiteData(data)))
    .catch(error => {
      const { message } = error;
      console.error(error);
      PublicStore.dispatch(fatalError(message));
    });
}

export function getBlog (id) {
  const { blogs } = PublicStore.getState();
  const blog = blogs.find(blog => blog.id === id);
  if (!blog) {
    console.error(`Blog not found: ${id}`);
    return null;
  }
  return blog;
}

export function getBlogPosts (id) {
  const blog = getBlog(id);
  if (!blog || !'posts' in blog) {
    console.log(`Couldn't get blogposts: ${id}`);
    return null;
  }
  return blog.posts;
};

export function getPost (blogId, postSlug) {
  const posts = getBlogPosts(blogId);
  const predicate = ({ slug }) => slug === postSlug;
  if (!posts || !posts.find(predicate)) {
    console.log(`Couldn't find post: ${postSlug} [in blog: ${blogId}]`);
  };
  return posts.find(predicate);
}



// WEBPACK FOOTER //
// ./client/Site/State/Actions.js